/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { freApi } from '@/store/apis';
import { combineReducers } from 'redux';
import loadingReducer from './loadingSlice';
import productList from './Products';
import feedbackReducer from './feedbackSlice';

const reducer = combineReducers({
    productList,
    loadingReducer,
    feedbackReducer,
    [freApi.reducerPath]: freApi.reducer,
});

export type RootState = ReturnType<typeof reducer>;

export default reducer;
